'use client';

import { useEffect } from 'react';
import { useAnalytics } from '@/services/frontendAnalyticsService';

export function LandingPageViewTracker() {
  const { landingPage } = useAnalytics();

  useEffect(() => {
    landingPage.pageViewed();
  }, [landingPage]);

  return null;
}
